/**
 * Web stub for @emotion/native used in Cypress component tests and E2E tests.
 *
 * @cabonline/ui-shared contains React Native components (button, input)
 * that import from @emotion/native. These components are never rendered in
 * web tests, but their presence in the bundle causes module-ID instability
 * errors at initialisation time because @emotion/native pulls in
 * @emotion/primitives-core which has a circular dependency with @emotion/react.
 *
 * This stub satisfies the @emotion/native import API so that:
 *   import styled, { css } from '@emotion/native';
 *   const Container = styled.View`...`;  ← works as a no-op
 *   const s = css`color: red;`;          ← works as a no-op
 *
 * IMPORTANT: The proxy's get trap deliberately returns `false` for `__esModule`
 * so webpack's CJS/ESM interop uses the whole `module.exports` (the proxy) as
 * the default import, instead of `module.exports.default`. Without this,
 * webpack sees `__esModule = <truthy function>` and resolves the default to
 * `taggedTemplate` (a plain function with no component properties), which then
 * causes "@emotion/babel-plugin"-compiled code like
 * `styled.TouchableOpacity("styles")` to fail at runtime.
 */

const css = function cssNoop() {
  return {};
};

// A no-op React component used as the result of all styled calls
function StyledNativeComponent() {
  return null;
}

// A proxy wrapping StyledNativeComponent so chained calls like
// styled(Component).withConfig({}).View`...` don't throw
const componentResultProxy = new Proxy(StyledNativeComponent, {
  get(_target, prop) {
    if (prop === '__esModule') return false;
    // styled(Comp).withConfig(...), styled(Comp).TouchableOpacity, etc.
    return function taggedTemplateFn() {
      return componentResultProxy;
    };
  },
});

const styled = new Proxy(
  function styledNoop() {
    // styled(Component) — return a result proxy that supports further chaining
    return componentResultProxy;
  },
  {
    get(_target, prop) {
      // Returning `false` here is critical: webpack's CJS/ESM interop checks
      // `module.exports.__esModule`. If it's truthy, webpack uses
      // `module.exports.default` as the default import (also a trap result,
      // breaking everything). Returning `false` makes webpack use the whole
      // `module.exports` (this proxy) as the default, so `styled` in consumer
      // code is correctly the proxy with full property support.
      if (prop === '__esModule') return false;

      // Named export `css` must resolve to the real cssNoop, not taggedTemplate
      if (prop === 'css') return css;

      // Convenience for code that accesses `.default` explicitly
      if (prop === 'default') return styled;

      // styled.View`...`, styled.Text`...`, styled.TouchableOpacity("styles"), etc.
      // @emotion/babel-plugin compiles `styled.Foo`template`` to
      // `styled.Foo("compiled-css-string")`, so this must return a callable
      // that produces a React component.
      return function taggedTemplateFn() {
        return componentResultProxy;
      };
    },
  }
);

module.exports = styled;
